import { render, staticRenderFns } from "./AddFlexLeagueScores.vue?vue&type=template&id=3bae1d2e&scoped=true&"
import script from "./AddFlexLeagueScores.vue?vue&type=script&lang=js&"
export * from "./AddFlexLeagueScores.vue?vue&type=script&lang=js&"
import style0 from "./AddFlexLeagueScores.vue?vue&type=style&index=0&id=3bae1d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae1d2e",
  null
  
)

export default component.exports